module.exports = __webpack_public_path__ + "static/media/44506953_2199889563419556_8459007874100625408_o.0b08d3c2.jpg";